import { render, staticRenderFns } from "./AddFontModal.vue?vue&type=template&id=3356d531&scoped=true&"
import script from "./AddFontModal.vue?vue&type=script&lang=ts&"
export * from "./AddFontModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddFontModal.vue?vue&type=style&index=0&id=3356d531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356d531",
  null
  
)

export default component.exports